import script from "./manage-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-settings.vue?vue&type=script&setup=true&lang=js"

import "./manage-settings.vue?vue&type=style&index=0&id=178e8632&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-178e8632"]])

export default __exports__